import React, { useEffect, useState } from 'react'
import { Fade, Modal } from '@mui/material'
import { useMutation } from 'convex/react'
import { api } from '../convex/_generated/api.js'
import './ApplicantForm.css'

const ApplicantForm = (props) => {
  const storeApplicants = useMutation(api.applicants.storeApplicant)
  const [open, setOpen] = React.useState(false)
  // eslint-disable-next-line no-unused-vars
  const [data, setData] = useState('')
  const generateUploadUrl = useMutation(api.applicants.generateUploadUrl);
  //const sendResume = useMutation(api.messages.sendImage);
  // eslint-disable-next-line no-unused-vars

  const [formData, setFormData] = useState({
    referralId: props.id,
    userId: props.userId,
    name: '',
    email: '',
    resume: null,
    jobId: ''
  })

  const handleSubmit = async (e) => {
    e.preventDefault()

    try {
      const formDataToSend = new FormData()
      formDataToSend.append('referralId', formData.referralId)
      formDataToSend.append('userId', formData.userId)
      formDataToSend.append('name', formData.name)
      formDataToSend.append('email', formData.email)
      formDataToSend.append('jobId', formData.jobId)
      const postUrl = await generateUploadUrl();
      // Step 2: POST the file to the URL
      const result = await fetch(postUrl, {
      method: "POST",
      headers: { "Content-Type": "application/pdf" },
      body: formData.resume,
      });
      const { storageId } = await result.json();
      // Step 3: Save the newly allocated storage id to the database
      formData.resume = storageId
      //await sendResume({ storageId });

      console.log(formData)
      storeApplicants(formData)
      window.alert("You have applied successfully")
      setOpen(false)
      
    } catch (error) {
      console.log(error)
    }
  }

  const handleInputChange = (e) => {
    const { name, value } = e.target
    setFormData((prevData) => ({
      ...prevData,
      [name]: value
    }))
  }

  const handleResumeUpload = (e) => {
    const file = e.target.files[0]
    setFormData((prevData) => ({
      ...prevData,
      resume: file
    }))
  }

  useEffect(() => {
   
    const json = async () => {
      try {
        const response = await fetch('https://company.clearbit.com/v2/companies/find?domain=' + props.companyname + '.com', {
          headers: {
            Authorization: `Basic ${btoa('sk_60880a8c7d1ee636cd33067bbdf222b8' + ':')}`
          }
        })
        if (!response.ok) {
          throw new Error('Failed to fetch data')
        }
        const result = await response.json()
        setData(result)
      } catch (error) {
        console.log(error)
      }
    }
    json()
  }, [])

  const handleOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  return (
    <>
    <button className='apply-radio' onClick={handleOpen}>Ask for a referral</button>
    {data
      ? <Modal open={open} onClose={handleClose} disableScrollLock >
    <Fade in={open}>
          <div className='detail-container'>
            <form onSubmit={handleSubmit} encType="multipart/form-data">
            <label> Applicant Name: </label>
            <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleInputChange}
          />

          <label>Applicant Email:</label>
          <input
            type="text"
            name="email"
            value={formData.email}
            onChange={handleInputChange}
            required
            pattern=".+@.+"
          />
          <br />
          <label> Resume (PDF only): </label>
          <input
            type="file"
            accept=".pdf"
            name="resume"
            onChange={handleResumeUpload}
          />
          <br />
          <br></br>
          <label>
            Paste the Job listing URL from the career&apos;s page :
          </label>
          <input
            type="text"
            name="jobId"
            value={formData.jobId}
            onChange={handleInputChange}
          />
          </form>
          <button className='close' onClick={handleClose}>Close</button>
          <button className='close' style={{ backgroundColor: "#7e51a1" }} onClick={handleSubmit}>Submit</button>
          </div>
    </Fade>
    </Modal>
      : <Modal open={open} onClose={handleClose}>
        <p>no data</p>
      </Modal>
    }
    </>
  )
}
export default ApplicantForm
